import axios from 'axios';
import config from 'api/urls-config.json';

export const getLanguages = () => {
    return axios.get(`${config.API + config.languages_list}`);
};

export const getCountries = () => {
    return axios.get(`${config.API + config.countries_list}`);
};
